
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 2v28h32V2H0zm12 18v-6h8v6h-8zm8 2v6h-8v-6h8zm0-16v6h-8V6h8zM10 6v6H2V6h8zm-8 8h8v6H2v-6zm20 0h8v6h-8v-6zm0-2V6h8v6h-8zM2 22h8v6H2v-6zm20 6v-6h8v6h-8z"}})])
          )
        }
      }
    